// ======================================================================
// FILE: src/modules/wms/dashboard/services/wmsDashboardService.js
// MODULE: Work Management System (WMS)
// FEATURE: Dashboard
//
// PURPOSE:
//   Frontend API service for the WMS Dashboard.
//
// BACKEND:
//   GET /api/wms/dashboard
//
// ARCHITECTURE:
//   - Uses existing axiosClient.
//   - Uses one consolidated dashboard API.
//   - Supports dashboard filters.
//   - Does not contain business logic.
// ======================================================================

import axiosClient from "../../../../api/axiosClient";


// ======================================================================
// LOAD DASHBOARD
// ======================================================================

async function getDashboard(filters = {}) {

  const params = {};

  // ----------------------------------------------------------
  // Search
  // ----------------------------------------------------------

  if (filters.search) {
    params.search = filters.search;
  }

  // ----------------------------------------------------------
  // Date
  // ----------------------------------------------------------

  if (filters.date_from) {
    params.date_from = filters.date_from;
  }

  if (filters.date_to) {
    params.date_to = filters.date_to;
  }

  // ----------------------------------------------------------
  // Team
  // ----------------------------------------------------------

  if (filters.team_id) {
    params.team_id = filters.team_id;
  }

  // ----------------------------------------------------------
  // Executive
  // ----------------------------------------------------------

  if (filters.executive_id) {
    params.executive_id =
      filters.executive_id;
  }

  // ----------------------------------------------------------
  // Priority
  // ----------------------------------------------------------

  if (filters.priority) {
    params.priority =
      filters.priority;
  }

  // ----------------------------------------------------------
  // Status
  // ----------------------------------------------------------

  if (filters.status) {
    params.status =
      filters.status;
  }

  // ----------------------------------------------------------
  // Work Mode
  // ----------------------------------------------------------

  if (filters.work_mode) {
    params.work_mode =
      filters.work_mode;
  }

  // ----------------------------------------------------------
  // API
  // ----------------------------------------------------------

  const res = await axiosClient.get(
    "/api/wms/dashboard",
    {
      params
    }
  );

  // ----------------------------------------------------------
  // Existing API response convention
  //
  // Expected:
  //
  // {
  //   success: true,
  //   message: "...",
  //   data: {...}
  // }
  //
  // Return only the dashboard data to
  // the React page.
  // ----------------------------------------------------------

  return res.data?.data || {};

}


// ======================================================================
// EXPORT
// ======================================================================

const wmsDashboardService = {

  getDashboard,

};

export default wmsDashboardService;